import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Trash2, Undo2 } from "lucide-react";
import { toast } from "sonner";
import { api } from "../../lib/api";
import DesinstallationPanel from "../DesinstallationPanel";
import TabContentEditor from "../TabContentEditor";
import TabFeed from "../TabFeed";
import { fmtDate } from "./SavFields";

export default function SavDesinstDetail({ sav, statuses, onReload, canDelete, onDelete }) {
  const [key, setKey] = useState(0);
  const dossier = { id: sav.dossier_id, extraction: sav.client || {} };
  const setStatus = async (status) => {
    try { await api.post(`/sav/${sav.id}/status`, { status }); toast.success("Statut mis à jour"); setKey((k) => k + 1); onReload(); }
    catch (e) { toast.error(e?.response?.data?.detail || "Changement impossible"); }
  };
  const changed = () => { setKey((k) => k + 1); onReload(); };
  return (
    <div className="px-8 py-6 max-w-6xl space-y-5" data-testid="sav-desinst-detail">
      <div className="flex items-start justify-between gap-4">
        <div>
          <div className="text-xs text-norea-textMuted"><Link to="/sav?vue=desinstallation" className="hover:underline">Service Après-Vente · Désinstallations</Link> / <Link to={`/dossiers/${sav.dossier_id}`} className="hover:underline" data-testid="sav-dossier-link">{sav.dossier?.label}</Link></div>
          <h1 className="font-heading text-3xl font-medium text-norea-text flex items-center gap-2"><Undo2 className="w-6 h-6 text-norea-primary" /><span data-testid="sav-reference">{sav.reference}</span></h1>
          <div className="text-xs text-norea-textMuted mt-1">Demande de désinstallation · ouverte le {fmtDate(sav.created_at)}{sav.migrated_at ? " · reprise de l'ancien onglet Désinstallation" : ""}</div>
        </div>
        <div className="flex items-center gap-2">
          <select value={sav.status} onChange={(e) => setStatus(e.target.value)} className="px-2.5 py-1.5 text-sm border border-norea-border rounded bg-white" data-testid="sav-status-select">
            {statuses.map((s) => <option key={s.id} value={s.id}>{s.label}</option>)}
          </select>
          {canDelete && <button onClick={onDelete} className="btn-ghost text-xs" title="Supprime la demande de la liste SAV (les données de désinstallation du dossier sont conservées)" data-testid="sav-delete"><Trash2 className="w-3.5 h-3.5" /></button>}
        </div>
      </div>
      <DesinstallationPanel key={`p-${key}`} dossier={dossier} onChanged={changed} />
      <section className="card-flat p-5" data-testid="sav-desinst-fields">
        <div className="flex items-center justify-between mb-3"><h3 className="font-heading text-base font-medium">Suivi de la désinstallation</h3>
          <Link to="/configuration/schemas?tab=desinstallation" className="text-[11px] text-norea-textMuted hover:underline">Paramétrer les champs</Link></div>
        <TabContentEditor key={`e-${key}`} dossierId={sav.dossier_id} tab="desinstallation" phones={[sav.client?.telephone]} onLinkedChange={changed} />
      </section>
      <TabFeed dossierId={sav.dossier_id} tab="desinstallation" refreshKey={key} title="Commentaires et historique" />
    </div>
  );
}
